/** « 0:47 » — les notes vocales se comptent en minutes, jamais en heures. */
export const formatTime = (seconds: number): string => {
  const total = Math.max(0, Math.floor(seconds));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

// Diamètre du pouce du `range`, en pixels. Le navigateur le garde dans le track : son centre court
// sur `largeur - THUMB_SIZE`, alors qu'un dégradé de remplissage court sur toute la largeur. Sans
// compensation, les deux se désynchronisent de quelques pixels sauf à mi-course.
export const THUMB_SIZE = 12;

/** Position du bord du remplissage, alignée sur le centre du pouce plutôt que sur la largeur nue. */
export const fillStopAt = (progress: number): string => `calc(${progress * 100}% + ${(0.5 - progress) * THUMB_SIZE}px)`;
